module.exports = __webpack_public_path__ + "static/media/unhealthy.b7d202a8.svg";